<template>
  <div class="form-group">
    <div class="form-group__newsletter">
      <span id="subscription-form" class="visually-hidden">Subscription Form</span>
      <input class="input" type="email" :class="stateClasses" :id="id" v-model="currentValue" name="email" aria-labelledby="subscription-form" :disabled="disabled" :placeholder="placeholder" v-bind="$attrs" :required="required" />
      <button type="submit" :class="buttonClasses" aria-label="Subscribe" :disabled="!buttonIsEnabled">
        <span class="visually-hidden">Subscribe</span>
        <icon name="chevron-right-thin" size="14px" fill="transparent" stroke="currentColor" />
      </button>
    </div>
  </div>
</template>

<script>
  import TextInput from 'scripts/components/forms/TextInput.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    components: {
      Icon,
    },

    extends: TextInput,

    computed: {
      valid() {
        const v = this.emailValidator(this.currentValue);

        return v;
      },

      buttonIsEnabled() {
        return this.valid && this.currentValue;
      },

      buttonClasses() {
        return {
          'btn btn--icon': true,
          'btn--disabled': !this.buttonIsEnabled,
        };
      },
    },

    methods: {
      emailValidator(value) {
        if (!value) {
          return true;
        }
        // eslint-disable-next-line no-useless-escape
        const pattern = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        return value.match(pattern);
      },
    },
  };
</script>

<style></style>
